module.exports = __webpack_public_path__ + "img/step4-fr@2x.dea89f52.webp";